import React from 'react';
import {withStyles} from '@material-ui/core/styles';


export default withStyles(theme => ({
  imageGrid: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    margin: `-${theme.spacing.unit}px -${theme.spacing.unit}px`,
  },
  imageGridItem: {
    '& img': {
      maxWidth: '100%',
    },
    padding: `${theme.spacing.unit}px ${theme.spacing.unit}px`,
    [theme.breakpoints.up('md')]: {
      flexBasis: '50%',
    }
  },
}))(function (props) {
  const {classes} = props;

  return (
    <ul className={classes.imageGrid}>
      {props.children.map((child, index) => (
        <li key={index} className={classes.imageGridItem}>
          {child}
        </li>
      ))}
    </ul>
  )
})


// WEBPACK FOOTER //
// ./src/parts/ImageGrid.js